module.exports = __webpack_public_path__ + "img/61.84f620f7.jpg";